<template>
    <div class="hierarchy-item">
        <div @click="toggleExpand" class="hierarchy-title" :class="{ 'drag-over': isDragOver }" draggable="true"
            @dragstart.stop="onDragStart" @dragover.prevent.stop="onDragOver" @dragleave.prevent.stop="onDragLeave"
            @drop.stop="onDrop">
            <b-icon :icon="hasFilhos ? 'folder-fill' : 'folder'" />
            <b-icon v-if="hasFilhos" :icon="expanded ? 'chevron-down' : 'chevron-right'" />
            <b-form-checkbox @change="selecionar(nodeLocal)" v-model="nodeLocal.selecionado" class="ml-3" :value="true"
                :unchecked-value="false" />
            <span class="node-text">{{ nodeLocal.sigla + ' - ' + nodeLocal.descricao }}</span>
        </div>

        <transition name="slide">
            <div v-if="expanded && hasFilhos" class="hierarchy-children">
                <TreeItem @selecionar="selecionar" @change-hierarchy="$emit('change-hierarchy', $event)"
                    v-for="filho in filhos" :key="filho.id" :node="filho" :recordsTree="recordsTree" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "TreeItem",
    components: {
        TreeItem: () => import("./TreeItem.vue")
    },
    props: {
        node: Object,
        recordsTree: Array,
    },
    data() {
        return {
            nodeLocal: this.node,
            expanded: true,
            isDragOver: false,
        };
    },
    computed: {
        filhos() {
            return this.recordsTree.filter(dep => dep.codDepartamentoSuperior === this.nodeLocal.id);
        },
        hasFilhos() {
            return this.filhos.length > 0;
        },
    },
    methods: {
        onDragStart(event) {
            event.dataTransfer.setData('nodeId', this.nodeLocal.id);
            event.dataTransfer.effectAllowed = 'move';
        },
        onDragOver() {
            this.isDragOver = true;
        },
        onDragLeave() {
            this.isDragOver = false;
        },
        onDrop(event) {
            this.isDragOver = false;
            const draggedId = event.dataTransfer.getData('nodeId');
            if (draggedId && Number(draggedId) !== this.nodeLocal.id) {
                this.$emit('change-hierarchy', { draggedId, targetId: this.nodeLocal.id });
            }
        },
        selecionar(node) {
            this.$emit("selecionar", { id: node.id, selecionado: node.selecionado });
        },
        toggleExpand() {
            if (this.hasFilhos) {
                this.expanded = !this.expanded;
            }
        },
    },
};
</script>

<style scoped>
.hierarchy-item {
    padding: 2px 0;
}

.hierarchy-title {
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: all 0.2s;
}

.hierarchy-title:hover {
    background-color: #ececec;
}

.hierarchy-title.drag-over {
    background-color: #d1ecf1;
    border: 1px dashed #0c5460;
    transform: scale(1.02);
}

.node-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.hierarchy-children {
    margin-left: 25px;
    padding-left: 10px;
    border-left: 1px solid #dee2e6;
}

.slide-enter-active,
.slide-leave-active {
    transition: opacity 0.2s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}
</style>